// extracted by mini-css-extract-plugin
module.exports = {"inputFile":"UploadAppButton__inputFile__2XKW9"};